import React from "react";

import {
  ModalMessageWrapper,
  ModalMessageBody,
  ModalMessageButton
} from './styles.js'

export default function ({ onClose, open, message }) {

  return (
    <>
      <ModalMessageWrapper  
        open={open}
      >
        <ModalMessageBody>
            <p data-testid="component-modal-message">{message}</p>
          <ModalMessageButton onClick={onClose}>
            Ok!
          </ModalMessageButton>
        </ModalMessageBody>
      </ModalMessageWrapper>
    </>
    )
}
